import { createPropertyActivatedAt, createPropertyExpiredAt } from '@general/helpers/propertyDates.helpers.js';

export const propertyOptions = {
    populationDensity: {
        SUBURBAN: {
            label: 'Suburban',
            // tooltip: 'Description of a suburban population.',
        },
        URBAN: {
            label: 'Urban',
            // tooltip: 'Description of an urban population.',
        },
        RURAL: {
            label: 'Rural',
            // tooltip: 'Description of a rural population.',
        },
    },
};

export const transformFormToProperty = formData => {
    // New properties don't have IDs
    const isNewProperty = !formData.id;

    const businessObj = [];
    if (formData.businesses) {
        const businesses = formData.businesses.filter(business => business !== '');
        businesses.forEach(business => {
            businessObj.push({ name: business, location: '', type: '' });
        });
    }

    return {
        title: formData.title,
        description: formData.description,
        subpremiseId: formData.subpremiseId,
        url: formData.url ?? '',
        location: formData.location,
        listingStatus: formData.listingStatus || null,
        purpose: formData.purpose,
        density: formData.density,
        squareFeet: formData.squareFeet,
        typeOfCenter: formData.typeOfCenter,
        typeOfFacility: formData.typeOfFacility,
        businesses: businessObj,
        activatedAt: isNewProperty ? createPropertyActivatedAt(formData.updatedAt) : formData.activatedAt,
        expiresAt: isNewProperty ? createPropertyExpiredAt(formData.updatedAt) : formData.expiresAt,
    };
};

export const uniqueListOfPropertyViews = propertyViews => {
    const uniquePropertyViewsArray = Object.values(
        // Create object with unique combination of createdAt, recordId, firstName, lastName, companyName and count
        propertyViews.reduce(
            (
                listOfPropertyViews,
                {
                    createdAt,
                    viewer: {
                        recordId,
                        firstName,
                        lastName,
                        company: { name: companyName },
                    },
                }
            ) => {
                // Create a key for checking unique values
                const key = `${recordId}|${firstName}|${lastName}|${companyName}`;

                // If key doesn't already exist, add new object with count of 0
                if (!listOfPropertyViews[key]) {
                    listOfPropertyViews[key] = { createdAt, recordId, firstName, lastName, companyName, count: 0 };
                }

                // Increment the count for each time key exists
                // eslint-disable-next-line no-plusplus
                listOfPropertyViews[key].count++;

                // return unique list of property views with filtered data
                return listOfPropertyViews;
            },
            {}
        )
    );
    const uniquePropertyViewsSorted = sortViewsByCountThenDate(uniquePropertyViewsArray);
    return uniquePropertyViewsSorted;
};

const sortViewsByCountThenDate = propertViewsArray => {
    // Sort the array by count and then by createdAt using
    const sortedArray = propertViewsArray.sort((a, b) => {
        // Sort by count in descending order
        const countDifference = b.count - a.count;
        if (countDifference !== 0) {
            return countDifference;
        }

        // Sort by createdAt in descending order for objects with equal counts
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    });

    return sortedArray;
};

export const convertUniquePropertyViewsToDropdown = (propertyViews, viewerId) => {
    const displayLabel = ({ companyName, count, firstName, lastName, recordId }) => {
        if (recordId === viewerId) {
            return `I have viewed (${count}) time${count > 1 ? 's' : ''}`;
        }

        return `${firstName} ${lastName} (${companyName}) viewed (${count}) time${count > 1 ? 's' : ''}`;
    };

    const options = propertyViews.map(item => {
        const option = {
            label: displayLabel(item),
            value: `${item.firstName}-${item.lastName}-${item.companyName}`,
        };

        return option;
    });

    return options;
};
